export default import.meta.ROLLDOWN_FILE_URL_ZF4YK7qmD2_wVKpRILxWJw